import Head from 'next/head';

const NoSeo = ({ title = 'Analítica Fantasy - No se encontró la página' }) => {
    return (
        <Head>
            <title>{title}</title>
            <meta charSet="utf-8" />
            <meta name="robots" content="noindex, nofollow" />
        </Head>
    );
};

export default NoSeo;
